// src/components/notes/note-card/note-card.styles.js
import styled from 'styled-components';

export const NoteCardContainer = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #fff;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }
`;

export const NoteCardTitle = styled.p`
  font-weight: bold;
  margin-bottom: 6px;
`;

export const NoteCardContent = styled.p`
  color: #333;
  font-size: 14px;
`;

export const NoteCardMeta = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 8px 0;
    font-size: 14px;
    width: 100%;
    max-width: 600px;
    text-align: left;
    line-height: 1.5;

    strong {
        font-weight: 600;
        display: inline-block;
        min-width: 90px;
    }
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
`;